import rq from 'components/RedQuick';
import Switch from '@mui/material/Switch';
import { Profile } from 'models';
import { useEffect, useState } from 'react';
import TitleService from 'title-service';
import './AddProfileFormContainer.scss';
import React from 'react';
import AvatarItem from './AvatarItem';
export default function AddProfileFormContainer(props: {
    contextId: string,
    onSave: (args: {
        profileName: string,
        isChild: boolean,
        profileImageName: string,
        profileImage: string
    }) => void
}) {
    let [isChild, setIsChild] = useState(false);
    let [profileImage, setProfileImage] = useState(resolveImgSrc('Ajani', 256));
    let [profileImageName, setProfileImageName] = useState('Ajani');
    let [openIconSelection, setOpenIconSeletion] = useState(false);
    let [name, setName] = useState('')
    const componentRef: React.Ref<HTMLDivElement> = React.useRef(null);
    const componentRef_size = rq.useContainerSize(componentRef);
    useEffect(() => {
        setName('');
        setIsChild(false);
        setProfileImage(resolveImgSrc('Ajani', 256));
        setProfileImageName('Ajani');
    }, [props.contextId]);

    let profileImagePrefixes = ['Ajani', 'Ausar', 'Auset', 'Beast', 'BeastWizard',
        'Boy', 'Cece', 'Corina', 'Cyrus', 'DeeJay',
        'DJ', 'Durasi', 'Emily', 'Girl', 'Heather', 'Homie', 'Ida', 'Iris', "Ja'Khari",
        'Jungul', 'Leo', 'Little Agent', 'McKenzie', 'Mia', 'Miko', 'Nehebet', 'Olivia', 'Pepper', 'Play',
        'Pookie', 'Prather', 'Princess', 'Roy', 'Seth', 'Shake', 'Silk', 'T', 'Thor', 'Watch'
    ];
    const rows = 7;
    const perRow = Math.max(10, Math.floor(profileImagePrefixes.length / rows));
    const lists: { color: string, component: any }[][] = [];
    const sections: string[] = [];
    if (openIconSelection) {
        for (let i = 0; i < rows; i++) {
            let inner_list: { color: string, component: any }[] = [];
            for (let j = 0; j < perRow; j++) {
                ///profileImagePrefixes[(i * (perRow) + j) % profileImagePrefixes.length]
                inner_list.push({
                    color: 'transparent',
                    component: <AvatarItem
                        onClick={() => {
                            setProfileImage(resolveImgSrc(profileImagePrefixes[(i * (perRow) + j) % profileImagePrefixes.length], (componentRef_size.width || 1000) / perRow));
                            setProfileImageName(profileImagePrefixes[(i * (perRow) + j) % profileImagePrefixes.length]);
                            setOpenIconSeletion(false);
                        }}
                        imgSrc={resolveImgSrc(profileImagePrefixes[(i * (perRow) + j) % profileImagePrefixes.length], (componentRef_size.width || 1000) / perRow)} />
                })
            }
            lists.push(inner_list);
            sections.push(TitleService('Characters'));
        }
    }
    return (
        <>
            <div className="sc-cBOTKl bcJSxL " ref={componentRef}>
                <div aria-label="Profile icon is currently set to Mickey Mouse. Select this to choose a different profile icon."
                    data-testid="Mickey Mouse" role="button"
                    tabIndex={0} className="sc-kLIISr sc-iGPElx fEHnoF" onClick={() => {
                        setOpenIconSeletion(true);
                    }}>
                    <div className="sc-dliRfk sc-jXQZqI jRYVoG profile-avatar" style={{
                        [profileImage ? 'background' : '--image-url']: `url(${profileImage}) 0% 0%/contain no-repeat`
                    }}>
                        <img aria-label="" name="edit" src="https://static-assets.bamgrid.com/product/disneyplus/images/edit.0a8445c2cff0e80361b2e66906aaeca0.svg" className="sc-etwtAo eTfMgc" />
                    </div>
                </div>
                <div className="sc-hkHFWD fCkTrG">
                    <fieldset className="sc-dVhcbM dtwHMx" display="inline">
                        <legend className="sc-fAjcbJ eIfxFy">addProfile</legend>
                        <span style={{ position: "relative", display: 'block' }}>
                            <input aria-label="Profile Name" data-testid="profile-name-input" display="inline" id="addProfile" maxLength="60"
                                value={name}
                                onChange={(evt) => {
                                    setName(evt.currentTarget.value)
                                }}
                                name="profileName" placeholder="Profile Name" type="text" className="sc-jAaTju fmqfIm sc-eqIVtm csbJFj text-color--primary body-copy form-input-text" />
                            <div className="metadata text-color--secondary padding--top-2 padding--left-1">
                            </div>
                        </span>
                    </fieldset>
                    <label aria-label="" aria-pressed="false" htmlFor="kidsMode" className="sc-gleUXh bphEKl form-label" tabIndex={0} style={{
                        flexDirection: 'row', justifyContent: 'space-between', margin: '0 auto'
                    }}>
                        <p className="body-copy margin--0 text-color--primary margin--left-2 margin--right-2">Kids Profile</p>
                        <div className="sc-doWzTn fleBqB">
                            <div>
                                <Switch checked={isChild || false} onChange={(evt, checked) => {
                                    setIsChild(checked);
                                }} name="kidsMode" id="kidsMode" inputProps={{ 'aria-label': isChild ? 'checked' : 'unchecked' }} />
                            </div>
                        </div>
                    </label>
                    <div className="metadata text-color--secondary text--left padding--top-2 padding--bottom-4 padding--left-3" style={{
                        boxShadow: 'rgba(255, 255, 255, 0.25) 0px -0.5px 0px 0px inset'
                    }}>A profile with curated content and features, and a simplified user interface.</div>
                    <button aria-label="SAVE" data-testid="add-profile-save-button"
                        role="button" value="submit"
                        className="sc-cvbbAY yfORX button button--primary " onClick={() => {
                            if (props.onSave) {
                                props.onSave({
                                    profileImageName,
                                    profileName: name,
                                    isChild,
                                    profileImage
                                });
                            }
                        }} id=""
                        kind="primary" type="button">{TitleService('SAVE')}</button>
                </div>
            </div>
            <rq.RedQuickScrollDialog
                open={openIconSelection}
                close={() => {
                    setOpenIconSeletion(false);
                }} >
                <div className='profile'>
                    <header className="sc-cANqwJ eQeHpR"><h2 className="text-color--primary">{TitleService('Choose Avatar')}</h2></header>
                </div>
                <div style={{ position: 'relative', zIndex: 10, overflow: 'hidden' }}>
                    <div style={{ position: 'relative' }}>
                        <rq.RedQuickLoLoList
                            lists={lists}
                            scaleActiveBy={1.1}
                            spaceHeight={80}
                            sections={sections}
                            itemsPerSlide={Math.min(Math.max(Math.floor(componentRef_size.width / 500 * 5), 1), 6)}
                            itemContainerCls="lolo__panel__container profile" />
                    </div>
                </div>
            </rq.RedQuickScrollDialog>
        </>
    );
}

function resolveImgSrc(characterName: string, width: any) {
    let image = [30, 64, 128, 256, 512, 1024].sort((b, a) => {
        return Math.abs(a - width) - Math.abs(b - width);
    });
    if (characterName === 'Beast' || characterName === 'BeastWizard') {
        return `/profile-images/${characterName}.png_${image[0]}.png`;
    }
    return `/profile-images/${characterName}_result.png_${image[0]}.png`;
}
